import { useEffect } from 'react'

import { isDesktopTarget, onDesktopAuthCallback } from '@maxus/website/lib'

import { exchangeTicket } from './exchange-ticket'

// Electron 渲染进程：订阅主进程经深链接（maxus://auth-callback?ticket=...）回传的登录 ticket，
// 换 token 落地登录态。仅 electron 目标生效（website 下桥缺失，onDesktopAuthCallback 返回 no-op）。
// 登录成功由 exchangeTicket 失效 auth 缓存后，外层 RedirectIfAuthed 自动导航。
export const useDesktopAuthCallback = (): void => {
  useEffect(
    () => {
      if (!isDesktopTarget) return
      return onDesktopAuthCallback(ticket => {
        void exchangeTicket(ticket).catch(err => {
          console.error('[desktop-auth-callback] exchange failed:', err)
        })
      })
    },
    [],
  )
}
